export function buildUrlWithQuery(pathname: string, queryString?: string): string {
  return [pathname, queryString].filter(Boolean).join('?');
}
